import z from 'zod'
import { decimalSchema } from '../utils/schema'

export const userTradeSchema = z.object({
  symbol: z.string(),
  tradeID: z.number(),
  orderID: z.number(),
  clOrdID: z.string(),
  side: z.enum(['BUY', 'SELL']),
  price: decimalSchema,
  quantity: decimalSchema,
  fee: decimalSchema.optional(),
  feeCoin: z.string().optional(),
  isMaker: z.boolean().optional(),
  time: z.number(),
})

export type UserTrade = z.infer<typeof userTradeSchema>
